'use client';

import { XMarkIcon } from '@heroicons/react/24/outline';
import { removeItem } from 'components/cart/actions';
import type { CartItem } from 'lib/shopify/types';
import { useRouter } from 'next/navigation';
import { useFormState } from 'react-dom';
import { cn } from 'utils/cn';

export function DeleteItemButton({
  item,
  optimisticUpdate,
  iconStyle = false
}: {
  item: CartItem;
  optimisticUpdate: any;
  iconStyle?: boolean;
}) {
  const router = useRouter();
  const [message, formAction, isPending] = useFormState(removeItem, null);
  const merchandiseId = item.merchandise.id;
  const actionWithVariant = formAction.bind(null, merchandiseId);
  const iconClasses = 'flex h-[24px] w-[24px] items-center justify-center rounded-full bg-white dark:bg-neutral-500 border-[1px] border-fp-gray' 
  const textClasses = 'text-[#E02424] flex underline items-center justify-center';
  const content = <XMarkIcon className="mx-[1px] h-4 w-4 dark:text-white text-black" />

  return (
    <form
      action={async () => {
        optimisticUpdate(merchandiseId, 'delete');
        await actionWithVariant();
        router.refresh()
      }}
      className={cn('', {'loading': isPending})}
    >
      <button
        type="submit"
        aria-label="Remove cart item"
        className={cn('', {
          [iconClasses]: iconStyle,
          [textClasses]: !iconStyle
        })}
      >
        {iconStyle ? content : 'Delete'}
      </button>
      <p aria-live="polite" className="sr-only" role="status">
        {message}
      </p>
    </form>
  );
}
